export enum InvoiceLayoutType {
    Invoice = 1,
    CreditNote = 2,
    Quote = 4,
    Order = 5,
    AccountStatement = 8,
    Reminder = 9,
    PurchaseOrder = 12,
}
